import Vue from 'vue'
import Vuex from 'vuex'
import Game from '@/store/modules/game'
import Result from '@/store/modules/result'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test'

export default new Vuex.Store({
  modules: {
    Game,
    Result
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js